export default {
      id: "icon-audiences-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-audiences",
      toString: function () {
        return this.url;
      }
    }